import { Tab, Tabs } from "@mui/material";

import type { ClientProfileTab } from "./pageHelpers";

export default function Client360ProfileTabs({
    activeTab,
    onChange,
}: {
    activeTab: ClientProfileTab;
    onChange: (tab: ClientProfileTab) => void;
}) {
    return (
        <Tabs
            value={activeTab}
            onChange={(_, value: ClientProfileTab) => onChange(value)}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{ mb: 2, borderBottom: 1, borderColor: "divider" }}
        >
            <Tab value="profile" label="Общ преглед" />
            <Tab value="team" label="Екип" />
            <Tab value="channel-retail" label="Магазин" />
            <Tab value="channel-b2b" label="B2B" />
            <Tab value="channel-online" label="Онлайн" />
            <Tab value="purchase-behavior" label="Покупателно поведение" />
            <Tab value="orders" label="Поръчки" />
            <Tab value="history" label="Пълна история" />
        </Tabs>
    );
}
